import {
  checkLoginUrl,
  loginUser,
} from '@disco/state-management/actions/UserActions'
import getReferrer from '@disco/utils/getReferrer'

import React, { useEffect } from 'react'
import { useDispatch, useSelector } from 'hooks/use-redux'
import { useNavigate } from 'react-router-dom'
import type { State } from 'types/redux'
import DiscoLogoSvg from 'assets/images/disco-logo.svg'
import ChangePassword from 'components/common/change-password'
import DocumentHeadTags from 'components/document-head-tags'
import LoginError from 'components/utils/login-error'
import styles from './password-welcome.module.css'

const PasswordWelcome = (): React.ReactElement<'div'> => {
  const user: State['user'] = useSelector(state => state.user)
  const dispatch = useDispatch()
  const navigate = useNavigate()
  useEffect(() => {
    // dispatch(checkLoginUrl(getReferrer()))
  }, [dispatch])
  useEffect(() => {
    if (user.loginUrlCheckError) {
      const error = user.loginUrlCheckError

      if (error.body && error.body[0] === 'referer already used') {
        navigate('/login?sessionExpired=1')
      }
    }
  }, [dispatch, user.loginUrlCheckError])

  const _onPasswordChange = async (password: string) => {
    await dispatch(
      loginUser(
        {
          new_password: password,
          referer: getReferrer(),
        },
        '/',
      ),
    )
  }

  const { loginUrlChecking, loginUrlCheckError, loggingIn, error } = user
  const passwordStrength =
    user.business?.public_metadata.password_strength ?? 'standard'
  let authState = <span />

  if (loginUrlChecking) {
    authState = <span>Authorizing...</span>
  } else if (loginUrlCheckError) {
    authState = (
      <div>
        <LoginError
          passwordStrength={passwordStrength}
          errorContext="link"
          error={loginUrlCheckError}
          suggestContactingSupport
        />
      </div>
    )
  } else {
    authState = (
      <ChangePassword
        type="welcome"
        passwordStrength={passwordStrength}
        passwordChangeInProgress={loggingIn}
        passwordChangeError={error}
        onPasswordChange={_onPasswordChange}
      />
    )
  }

  return (
    <div className={`PostInvites_Content ${styles.pageContent}`}>
      <DocumentHeadTags title="Set password | DISCO" />
      <DiscoLogoSvg className={styles.pageLogo} />
      <div className={styles.card}>
        <h1 className={styles.cardTitle}>Set your DISCO password</h1>
        {authState}
      </div>
    </div>
  )
}

export default PasswordWelcome
